import { httpClient } from './httpClient';

const base = '/api/documentos';

function getAuthHeader() {
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export const subirDocumento = async ({ file, estudiante_id, tipo_documento, descripcion }) => {
  const formData = new FormData();
  if (file) formData.append('documento', file);
  if (estudiante_id !== undefined) formData.append('estudiante_id', estudiante_id);
  if (tipo_documento !== undefined) formData.append('tipo_documento', tipo_documento);
  if (descripcion) formData.append('descripcion', descripcion);

  const res = await fetch(`${httpClient.baseUrl}${base}/subir`, {
    method: 'POST',
    headers: {
      ...getAuthHeader(),
    },
    body: formData,
  });

  let data = null;
  const ct = res.headers.get('content-type') || '';
  if (ct.includes('application/json')) {
    try { data = await res.json(); } catch { data = null; }
  } else {
    try { data = await res.text(); } catch { data = null; }
  }

  if (!res.ok) {
    const message = (data && (data.message || data.error)) || res.statusText || 'Error al subir documento';
    const err = new Error(message);
    err.status = res.status;
    err.data = data;
    throw err;
  }

  return data;
};

export const listarDocumentos = (estudianteId) =>
  httpClient.get(`${base}/estudiante/${estudianteId}`);

const buildTokenQuery = () => {
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
  return token ? `?token=${encodeURIComponent(token)}` : '';
};

export const verDocumentoUrl = (id) => `${httpClient.baseUrl}${base}/${id}/ver${buildTokenQuery()}`;
export const descargarDocumentoUrl = (id) => `${httpClient.baseUrl}${base}/${id}/descargar${buildTokenQuery()}`;
export const eliminarDocumento = (id) => httpClient.del(`${base}/${id}`);
export const actualizarEstadoDocumento = (id, payload) =>
  httpClient.patch(`${base}/${id}/estado`, payload);

export const marcarNoAplicaDocumento = (payload) =>
  httpClient.post(`${base}/no-aplica`, payload);

const documentosService = {
  subir: subirDocumento,
  listar: listarDocumentos,
  verUrl: verDocumentoUrl,
  descargarUrl: descargarDocumentoUrl,
  eliminar: eliminarDocumento,
  actualizarEstado: actualizarEstadoDocumento,
  marcarNoAplica: marcarNoAplicaDocumento,
};

export default documentosService;
